import { Edit, FormDataConsumer, Labeled, ReferenceInput, SaveButton, SelectInput, SimpleForm, Toolbar, useDataProvider, useNotify, useRefresh } from "react-admin";
import { Permissions, PriceInput, Tooltip } from "../../components";
import { PERMISSIONS } from '../../constants';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import { getChainId, getStationId } from "../../utils/utils";
import { UserRole } from "../../providers/authProvider";
import { BusinessModel } from "../../models";

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: 300,
    marginTop: 40,
  },
}));

const FuelInput = ({ stationId, fuelId, label, stationFuels }: any) => {
  const placeIndex = stationFuels.findIndex((item: any) => item.stationId === stationId);
  const fuelIndex = stationFuels[placeIndex].fuels.findIndex((item: any) => item.fuelId === fuelId);

  return (
    <Labeled label={label}>
      <Tooltip sxContainer={{ alignItems: 'flex-start' }} placement="top-start" title="Se o campo for deixado como zero, o valor não será exibido." >
        <PriceInput
          source={`stationFuels[${placeIndex}].fuels[${fuelIndex}].price`}
          label="Preço por litro"
          precision={3}
          //@ts-ignore
          locales="pt-BR"
        />
      </Tooltip>
    </Labeled>
  );
};

const StationFuels = ({ stationFuels, stationId }: any): any => {
  const [fuels, setFuels] = useState([]);
  const [loading, setLoading] = useState(false);
  const dataProvider = useDataProvider();

  useEffect(() => {
    setLoading(true);
    //@ts-ignore
    dataProvider.getList('fuels', { sort: { field: 'name', order: 'ASC' }, pagination: { page: 1, perPage: false }, filter: { stationId } })
      .then(({ data }: any) => {
        setFuels(data);
      }).finally(() => setLoading(false));
  }, [stationId]);

  if (loading) { return null; }

  return (
    fuels.map(({ id, name }) => (
      <FuelInput stationFuels={stationFuels} stationId={stationId} fuelId={id} label={name} />
    ))
  );
};

const FuelPrices = () => {
  const classes = useStyles();
  const notify = useNotify();
  const refresh = useRefresh();
  const navigate = useNavigate();

  const onSuccess = () => {
    notify('ra.notification.updated', { messageArgs: { smart_count: 1 } });
    refresh();
  };

  const onError = () => {
    notify('ra.notification.data_provider_error', { type: 'error' });
    navigate('/fuel-prices-edit');
  };

  const transformPrices = (values: any) => {
    return (
      values.stationFuels.filter((pl: any) => pl?.stationId === values?.stationId).map(({ fuels, ...rest }: any) => ({
        ...rest, fuels: fuels.map(({ fuelId, stationId, price }: any) => ({ fuelId, stationId, price: price > 0 ? price : null }))
      }))[0]
    );
  };

  const ToolbarCustom = () => {
    return (
      <Toolbar>
        <SaveButton label="Atualizar" />
      </Toolbar>
    );
  }

  return (
    //@ts-ignore
    <Permissions userRoles={[UserRole.chain, UserRole.station]} permissions={[PERMISSIONS.FUEL_PRICE]}>
      <Edit id={getChainId()} transform={transformPrices} title="Preço do Combustível" resource="fuel-prices" mutationMode="pessimistic" mutationOptions={{ onSuccess, onError }}>
        <SimpleForm toolbar={<ToolbarCustom />} defaultValues={{ stationId: getStationId() ?? null }} >
          <div className={classes.container}>
            {
              !getStationId() &&
              <ReferenceInput
                filter={{ chainId: getChainId(), businessModelToExclude: BusinessModel.pumpxPro }}
                sort={{ field: 'name', order: 'ASC' }}
                source="stationId"
                reference="stations"
                //@ts-ignore
                perPage={null}
              >
                <SelectInput
                  label="Local"
                  optionText="name"
                  emptyText="ra.action.clear_input_value"
                />
              </ReferenceInput>
            }
            <FormDataConsumer>
              {({ formData: { stationId, stationFuels } }) =>
                stationId && (<StationFuels stationFuels={stationFuels} stationId={stationId} />)
              }
            </FormDataConsumer>
          </div>
        </SimpleForm>
      </Edit>
    </Permissions>
  );
}

export default FuelPrices;